// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"255":"3b7f83a9","787":"c45011b9"}[chunkId] + ".chunk.js";
};